import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getEcommerceArticleDisclaimerVerbiage } from 'lib/articleUtilities';
import styles from './styles.module.scss';

class HeaderDisclaimer extends React.Component {
  static propTypes = {
    stylesOverride: PropTypes.shape({
      containerStyles: PropTypes.string,
      cardStyles: PropTypes.string,
      buttonStyles: PropTypes.string,
    }),
    disclaimer: PropTypes.string,
    isStackCommerce: PropTypes.bool,
  };

  static defaultProps = {
    stylesOverride: {
      containerStyles: '',
      cardStyles: '',
      buttonStyles: '',
    },
    disclaimer: getEcommerceArticleDisclaimerVerbiage('legacyTodayGiftGuideText', 'text'),
    isStackCommerce: false,
  }

  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  disclaimer = () => {
    this.setState(({ open }) => ({ open: !open }));
  };

  arrow = () => {
    const { open } = this.state;
    return (
      <svg
        className={classNames('items-center', {
          [styles.upCaret]: open,
        })}
        width="10"
        height="7"
        viewBox="0 0 10 7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1 1.07454L4.96238 5L9 1" stroke="white" strokeWidth="2" strokeLinecap="round" />
      </svg>
    );
  }

  card = () => {
    const { disclaimer, stylesOverride } = this.props;
    const { cardStyles } = stylesOverride;
    return (
      <div className={classNames('tl absolute z-2 br1-m left0 right0', styles.card, cardStyles)} data-test="card">
        <div className="relative fl publico-txt f2 gray-80 pl7 pr7 pt5 pb5 lh-copy">
          {disclaimer}
        </div>
      </div>
    );
  }

  render() {
    const { open } = this.state;
    const { stylesOverride, isStackCommerce } = this.props;
    const { buttonStyles, containerStyles } = stylesOverride;

    return (
      <div
        className={classNames('df flex-column mt5', styles.disclaimerContainer, containerStyles)}
        data-test="container"
      >
        <button
          type="button"
          className={classNames(
            'css-reset-btn df justify-center items-center',
            buttonStyles,
          )}
          onClick={this.disclaimer}
          data-test="button"
        >
          <div className="fs-italic f3 gray-80 white lh-copy">{!open ? 'Show Disclaimer' : 'Hide Disclaimer'}</div>
          <div className="pl2">
            {this.arrow()}
          </div>
        </button>
        <div className="relative" data-test="card-container">
          <div className={classNames(styles.line, { 'o-0': open, mt3: !isStackCommerce })} />
          {open && this.card()}
        </div>
      </div>
    );
  }
}


export default HeaderDisclaimer;
